import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { getOrdersList } from '../../shared/api/user';
import tone from '../../audio/notify.mp3';
import toast, { Toaster } from 'react-hot-toast';

export default function BasicTable() {

  const [orders, setOrders] = useState([]);
  const previousOrdersRef = useRef([]);
  const [isNewOrderAdded, setIsNewOrderAdded] = useState(false);
  const [notificationSent, setNotificationSent] = useState(false);

  const init = async () => {
    let rows = await getOrdersList;
    setOrders(rows.data.orders);

    const newOrders = rows.data.orders.filter(order => !previousOrdersRef.current.some(prevOrder => prevOrder._id === order._id));

    if (newOrders.length > 0) {
      const latestOrderTimestamp = moment(newOrders[0].createdAt).valueOf();
      const lastNotificationTimestamp = localStorage.getItem('lastNotificationTimestamp');
      if (lastNotificationTimestamp === null || latestOrderTimestamp > Number(lastNotificationTimestamp)) {
        // setLatestOrderTime(moment(newOrders[0].createdAt).format('YYYY-MM-DD HH:mm:ss'));
        setIsNewOrderAdded(true); // Set the flag to true if a new order was added
        setNotificationSent(false); // Reset the notificationSent flag when a new order is added
        localStorage.setItem('lastNotificationTimestamp', latestOrderTimestamp); // Store the latest order timestamp in localStorage
      }
    }

    // Update the previousOrdersRef with the current orders
    previousOrdersRef.current = rows.data.orders;
  }
  useEffect(() => {
    init();
    // Fetch orders every 15 seconds
    const interval = setInterval(() => {
      init();
    }, 25000);

    // Get previous orders from localStorage
    const previousOrders = JSON.parse(localStorage.getItem('previousOrders'));
    // Update the previousOrdersRef with the previous orders
    previousOrdersRef.current = previousOrders || [];

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    // Show notification when a new order is added
    if (isNewOrderAdded && !notificationSent) {
      showNotification();
      setNotificationSent(true);
    }
  }, [isNewOrderAdded, notificationSent]);

  const showNotification = async () => {
    let audio = new Audio(tone);
    audio.play();
    notify();
  }

  const notify = () => toast('A new order has been received.');
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Chef Name</TableCell>
            <TableCell align="right">Customer Name</TableCell>
            <TableCell align="right">Dish</TableCell>
            <TableCell align="right">Order Status</TableCell>
            <TableCell align="right">Order Type</TableCell>
            <TableCell align="right">Payment Status</TableCell>
            <TableCell align="right">Total Price</TableCell>
            <TableCell align="right">Edit Order</TableCell>
            <TableCell align="right">Delete Order</TableCell>
            <TableCell align="right">Order Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((row) => (
            <TableRow
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.chef.firstName} {row.chef.lastName}
              </TableCell>
              <TableCell align="right">{row.user.firstName} {row.user.lastName}</TableCell>
              <TableCell align="right">{row.orderItems[0].dish.dishName}</TableCell>
              <TableCell align="right">{row.orderStatus}</TableCell>
              <TableCell align="right">{row.orderType}</TableCell>
              <TableCell align="right">{row.paymentStatus}</TableCell>
              <TableCell align="right">{`Rs. ${row.total}`}</TableCell>
              <TableCell align="right"><Button variant="text"><EditIcon></EditIcon></Button></TableCell>
              <TableCell align="right"><Button variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
              <TableCell align="right">{moment(row.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Toaster />
    </TableContainer>
  );
}